import { get, post1 } from "../request.js";

// 验证码接口
export const getCaption = () => {
  return get("/api/tms/account/captcha");
};

// 登录
export const login = (data) => {
  return post1("/api/tms/account/loginByPassword", data);
};

export const validateApi = (data) => {
  return post1("/api/external/risk/validateAll", data);
};
